// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__25400","tabsBox":"styles_tabsBox__1gY2t","createButton":"styles_createButton__1JJPf"};